const data = [
    {
        name: "Prof. N R Mandal",
        position: "PRESIDENT",
        imageUrl: "/images/founder.webp",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Aniruddh Solanki",
        position: "GENERAL SECRETARY",
        imageUrl: "/assets/images/members/Aniruddh Solanki.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Gopi Sravani",
        position: "VICE PRESIDENT",
        imageUrl: "/assets/images/members/Sravani Gopi.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Mridul Gupta",
        position: "ASSISTANT SECRETARY AND HUMAN RESOURCE MANAGER",
        imageUrl: "/assets/images/members/Mridul Gupta.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Aditya Mallick",
        position: "TREASURER",
        imageUrl: "/assets/images/members/Aditya Mallick.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Ayushi Sharma",
        position: "SCHOOL DEVELOPMENT OFFICER",
        imageUrl: "/assets/images/members/Ayushi Sharma.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Parv Maheshwari",
        position: "CHIEF FUNDRAISING OFFICER",
        imageUrl: "/assets/images/members/Parv Maheshwari.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Keerthi Reddy Samreddy",
        position: "HOSTEL COMMITTEE OFFICER",
        imageUrl: "/assets/images/members/Keerthi Reddy Samreddy.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Akash Agarwal",
        position: "CHIEF EXECUTIVE OFFICER, LiGHT",
        imageUrl: "/assets/images/members/Akash Agarwal.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Naman Goel",
        position: "CHIEF TECHNICAL OFFICER + PUBLIC RELATION OFFICER",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Eshita Chandwani",
        position: "FOREIGN AND CORPORATE RELATION OFFICER",
        imageUrl: "/assets/images/members/Eshita Chandwani.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
]

export default data;